<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column is-two-thirds">
        <div class="box">
          <h1 class="title has-text-centered">Welcome to Plastic Collection Admin</h1>
          <h2 class="subtitle has-text-centered">Helping Recycle America's Plastic</h2>

          <p class="has-text-centered">
            This site is meant for Customer Service Representatives, Dispatchers, and
            System Adminstrators. If you are looking for our Driver Application or
            Customer Application, please follow the appropriate links below.
          </p>
          <br>

          <div class="columns is-multiline">
            <div class="column is-half">
              <router-link to="login" class="box title is-4 has-text-centered">
                Login
              </router-link>
            </div>

            <div class="column is-half">
              <router-link to="register" class="box title is-4 has-text-centered">
                Request Access
              </router-link>
            </div>

            <div class="column is-half">
              <div class="box title is-4 has-text-centered">
                Driver Application
              </div>
            </div>

            <div class="column is-half">
              <div class="box title is-4 has-text-centered">
                Customer Application
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Landing',

  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$store.getters['auth/hasToken']) {
        next({ name: 'Dashboard' })
      } else {
        next()
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/bulma';

  .box.title.is-4.has-text-centered {
    display: flex;
    height: 20vh;
    min-height: 200px;

    align-items: center;
    justify-content: center;

    &:hover {
      @extend .hero.is-link;
    }
  }
</style>
